// @flow
import React from 'react';
import { get, isEmpty } from 'lodash';
import { connect } from 'react-redux';
import { compose, pure } from 'recompose';
import moment from 'moment';
import { reduxForm, Form, Field } from 'redux-form';
import Loader from 'angieslist-app-platform/lib/browser/Loader';
import { analytics } from 'angieslist-app-platform';
import { InputField } from 'angieslist-app-platform/lib/browser/forms';
import { Col, Row } from 'angieslist-react-components';
import { defaultPageProps } from '../../../../app/browser/analyticsDefaultProperties';
import { itemClicked } from '../../../../app/browser/analyticsHelpers';
import HourField from './HoursField';
import RequiredField from '../../../common/requiredField';
import { goToError } from './utils/Utils';
import './EditHours.scss';

const editHoursFormName = 'editHoursForm';

type Props = {
  handleSubmit: () => void,
  editHoursForm: Object,
  change: Function,
};

type State = {
  prevFormData: Object
}

type DayValues = {
  isClosed: boolean,
  openTime: string,
  closeTime: string
};

const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
const timeFormats = ['hh:mm a', 'h:mm a', 'HH:mm', 'H:mm'];

const validateHours = (editHourValues) => {
  const errors = {};
  days.forEach((day) => {
    if (!editHourValues[`isClosed${day}`] && !editHourValues.open247) {
      if (!moment(editHourValues[`open${day}`], timeFormats, true).isValid()) {
        errors[`open${day}`] = 'invalid hours format';
      }
      if (isEmpty(editHourValues[`open${day}`])) errors[`open${day}`] = 'hours are required';

      if (!moment(editHourValues[`close${day}`], timeFormats, true).isValid()) {
        errors[`close${day}`] = 'invalid hours format';
      }
      if (isEmpty(editHourValues[`close${day}`])) errors[`close${day}`] = 'hours are required';
    }
  });
  return errors;
};

function formatHour(mins) {
  const time = mins || 0;
  return moment('00:00', timeFormats).add(time, 'minutes').format('hh:mm a');
}

const changeHours = (change: Function, day: string, dayValue: DayValues) => {
  change(`isClosed${day}`, dayValue.isClosed);
  change(`open${day}`, dayValue.openTime);
  change(`close${day}`, dayValue.closeTime);
};


class EditHoursComponent extends React.Component<Props, State> {
state: State = { prevFormData: {} }
props: Props

toggle247 = (event, open247) => {
  const { change, editHoursForm } = this.props;
  const { prevFormData } = this.state;
  if (open247) {
    this.setState({ prevFormData: editHoursForm.values });
    days.forEach((day) => {
      changeHours(change, day, {
        isClosed: false,
        openTime: formatHour(0),
        closeTime: formatHour(0),
      });
    });
  }
  if (!open247) {
    days.forEach((day) => {
      changeHours(change, day, {
        isClosed: prevFormData[`isClosed${day}`],
        openTime: prevFormData[`open${day}`],
        closeTime: prevFormData[`close${day}`],
      });
    });
    this.setState({ prevFormData: {} });
  }
}


render() {
  const {
    handleSubmit,
    editHoursForm,
    change,
  } = this.props;

  const hoursFormCurrentValues = get(editHoursForm, 'values', {});
  return (
    <div id="Edit-Hours-Component-Container">
      <RequiredField class="show-mobile hours-mobile" />
      <div style={{ display: 'flex' }}>
        <div id="hours-title" className="page-name">
          Hours
        </div>
        <RequiredField class="margin-hours-page" />
      </div>
      <p className="margin-l10 margin-b20">Add your hours to your business profile so that customers know when they can reach you.</p>
      <Loader
        loading={isEmpty(editHoursForm)}
        element={
          <div className="text-center" style={{ marginTop: '1em' }}>
            <i className="icon icon-load icon-spin icon-3x text-primary" />
          </div>}
      >
        <Form
          className="margin-l10"
          onSubmit={handleSubmit}
          onSubmitFailed={goToError()}
          name="editHoursForm"
        >
          <Row className="margin-b20">
            <Col xs={12}>
              <Field
                name="byAppointment"
                label="By appointment only"
                id="Edit-Hours--By-Appointment"
                component={InputField}
                type="checkbox"
              />
              <p className="apt-helper-text">I don’t have set hours, but I accept appointment requests.</p>
            </Col>
          </Row>
          <Row className="margin-b20">
            <Col md={6} xs={6}>
              <Field
                name="open247"
                label="Available 24/7"
                id="Edit-Hours--Open-247"
                component={InputField}
                type="checkbox"
                onChange={this.toggle247}
              />
            </Col>
          </Row>
          { days.map(day => (
            <HourField
              day={day}
              openHours={get(hoursFormCurrentValues, `open${day}`, '')}
              closeHours={get(hoursFormCurrentValues, `close${day}`, '')}
              open247={get(hoursFormCurrentValues, 'open247', false)}
              isClosed={get(hoursFormCurrentValues, `isClosed${day}`, false)}
              change={change}
              key={`hour-field-${day}`}
            />
          ))}
        </Form>
      </Loader>
    </div>);
}
}

const editHoursAnalytics = {
  page: {
    name: 'SP : My Business : Business Hours',
    properties: {
      ...defaultPageProps,
    },
  },
  elements: {
    'Edit-Hours--By-Appointment': itemClicked('SP : My Business : Business Hours', 'My Business : Hours'),
    'Edit-Hours--Open-247': itemClicked('SP : My Business : Business Hours', 'My Business : Hours'),
    'Edit-Hours--isClosed-*': itemClicked('SP : My Business : Business Hours', 'My Business : Hours'),
    'Edit-Hours--Open-*': itemClicked('SP : My Business : Business Hours', 'My Business : Hours'),
    'Edit-Hours--Closed-*': itemClicked('SP : My Business : Business Hours', 'My Business : Hours'),
  },
};

export default (compose(
  connect(state => ({
    editHoursForm: state.form[editHoursFormName],
  })),
  reduxForm({
    form: editHoursFormName,
    validate: values => validateHours(values),
    destroyOnUnmount: false,
  }),
  analytics({
    ruleset: editHoursAnalytics,
  }),
  pure,
)(EditHoursComponent): any);



// WEBPACK FOOTER //
// ./src/modules/profile/browser/components/EditHours.js